import React, { useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { Button as Btn, Typography } from "@material-ui/core";
import { DarkGrey, PrimaryColor } from "../../shared/styles/colors";
import DeleteModal from "../modal/DeleteModal";
import CloseIcon from "@mui/icons-material/Close";
import Service from "../../model/service";
import DB_Status from "../../model/enum/status.class";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import EditIcon from "../../assets/admin/edit-icon.svg";
import ApiService from "../../service/ApiService";
import { DatabaseEntities } from "../../model/enum/database-entities.enum";
import AlertService from "../../service/AlertService";
import ToastMessages from "../../model/enum/toast-messages.enum";
import useStyles from "./styles";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30rem",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "8px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  maxHeight: "90vh", // Restrict maximum height to 80% of the viewport height
  overflowY: "auto", // Enable vertical scrolling
  "@media (max-width: 640px)": {
    width: "80%",
  },
};

const ServiceModal = ({ service, resetList }: any) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const edit = service != null;
  const [name, setName] = useState(edit ? service.name : "");
  const [availability, setAvailability] = useState(
    edit ? service.available : true,
  );

  const handleName = (e: any) => setName(e.target.value);
  const handleAvailability = () => setAvailability(!availability);

  const handleCreate = async (payload: Service) => {
    await ApiService.post<Service>(DatabaseEntities.SERVICES, payload)
      .then(() => {
        AlertService.success(ToastMessages.CREATED);
        resetList();
      })
      .catch(() => {
        AlertService.error(ToastMessages.CREATE_FAILED);
      });
  };

  const handleUpdate = async (payload: Service) => {
    await ApiService.put<Service>(
      `${DatabaseEntities.SERVICES}/${payload.id}`,
      payload,
    )
      .then(() => {
        AlertService.success(ToastMessages.UPDATED);
        resetList();
      })
      .catch(() => {
        AlertService.error(ToastMessages.UPDATE_FAILED);
      });
  };

  const handleDelete = async (payload: Service) => {
    await ApiService.delete<any>(`${DatabaseEntities.SERVICES}/${payload.id}`)
      .then(() => {
        AlertService.success(ToastMessages.DELETED);
        resetList();
      })
      .catch(() => {
        AlertService.error(ToastMessages.DELETE_FAILED);
      });
  };

  const invalidInput = (): boolean => {
    return name === "";
  };

  const submit = async () => {
    if (invalidInput()) return;

    let payload: Service = {
      id: edit ? service.id : 0,
      name: name,
      available: availability,
    };

    if (edit) await handleUpdate(payload);
    else await handleCreate(payload);

    handleClose();
  };

  return (
    <div>
      {edit ? (
        <Button onClick={handleOpen}>
          <img src={EditIcon} alt="edit icon" />
        </Button>
      ) : (
        <Btn
          className={classes.headerButton}
          variant="contained"
          onClick={handleOpen}
        >
          + Add Service
        </Btn>
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: "auto" }}
      >
        <Box sx={style}>
          <div className={classes.headerDiv}>
            {edit ? (
              <Typography className={classes.title}>
                <DeleteModal item={service} handleDelete={handleDelete} />
              </Typography>
            ) : (
              <Typography className={classes.title}>Add new service</Typography>
            )}
            <Button onClick={handleClose} sx={{ color: "black" }}>
              <CloseIcon />
            </Button>
          </div>
          <hr />
          <div className={classes.form}>
            <input
              className={classes.input}
              value={name}
              onChange={handleName}
              placeholder="Name"
            />
            <div className={classes.availabilityDiv}>
              <Typography>{DB_Status.AVAILABLE}:</Typography>
              <Button
                sx={{ color: availability ? PrimaryColor : DarkGrey }}
                onClick={handleAvailability}
              >
                {availability ? <ToggleOnIcon /> : <ToggleOffIcon />}
              </Button>
            </div>
          </div>
          <div className={classes.buttonDiv}>
            <Btn
              className={classes.button}
              onClick={submit}
              disabled={invalidInput()}
            >
              {edit ? "Save" : "Create"}
            </Btn>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default ServiceModal;
